import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useUpdateShareBoardLink } from "~/components/SharePrivateBoardModal/hooks/useUpdateShareBoardLink";
import { SharePrivateContentSettings } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePrivateContentSettings";
export const SharePrivateBoardSettings = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, boardId, userPermissions } = param;
    const { onShortUrlUpdate, isLoading } = useUpdateShareBoardLink({
        boardId,
        shortIdInfo
    });
    return /*#__PURE__*/ _jsx(SharePrivateContentSettings, {
        shortIdInfo: shortIdInfo,
        onShortUrlUpdate: onShortUrlUpdate,
        isLoading: isLoading,
        userPermissions: userPermissions
    });
});
SharePrivateBoardSettings.displayName = "SharePrivateBoardSettings";
